export type ColumnVirtualizationRange = {
  startIndex: number;
  endIndex: number;
};

let currentRange: ColumnVirtualizationRange = { startIndex: 0, endIndex: 0 };
const subscribers: { [id: string]: () => void } = {};

const ColumnVirtualizationService = {
  getRange: (): ColumnVirtualizationRange => currentRange,

  setRange: ({ startIndex, endIndex }: ColumnVirtualizationRange) => {
    if (
      currentRange.startIndex === startIndex &&
      currentRange.endIndex === endIndex
    ) {
      return;
    }
    currentRange = { startIndex, endIndex };
    Object.values(subscribers).forEach((notifyCallback) => notifyCallback());
  },

  subscribe: (notifyCallback: () => void) => {
    const subscriptionId = Math.floor(Math.random() * Date.now()).toString(36);
    subscribers[subscriptionId] = notifyCallback;
    return {
      unsubscribe: () => {
        delete subscribers[subscriptionId];
      },
    };
  },

  reset: () => {
    currentRange = { startIndex: 0, endIndex: 0 };
  },
};

export default ColumnVirtualizationService;
